<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
    </div>
    <div class="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
      <Message v-for="(msg, index) in messages" :severity="msg.severity" :key="index" :life="5000" :sticky="false">{{msg.content}}</Message>
      <div class="card p-fluid">
        <h3>User Profile</h3>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">User ID</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <InputText :value="this.$store.getters.authUserId" readonly />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Name</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <InputText :value="this.$store.getters.authName" readonly />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Email</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <InputText :value="this.$store.getters.authEmail" readonly />
          </div>
        </div>
        <div v-if="this.$store.getters.authCustomerId" class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Company</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <InputText :value="mapCompany(this.$store.getters.authCustomerId)" readonly />
          </div>
        </div>
        <div v-if="this.$store.getters.authBranchId" class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Branch</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <InputText :value="mapBranch(this.$store.getters.authBranchId)" readonly />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Roles</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <Tag v-for="role in this.$store.getters.authRoles" :key="role.id" :value="role" class="p-mr-2 p-mb-2" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Permissions</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <Tag v-for="permission in this.$store.getters.authPermissions" :key="permission.id" :value="permission" class="p-mr-2 p-mb-2" severity="warning" />
          </div>
        </div>
        <div class="p-field p-grid" v-if="this.$store.getters.authLastSignin">
          <label class="p-col-12 p-mb-2 p-sm-12 p-md-2 p-mb-md-0">Last Login</label>
          <div class="p-col-12 p-sm-12 p-md-10">
            <InputText :value="this.$store.getters.authLastSignin" readonly />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserProfile",

  data() {
    return {
      breadcrumbHome: { icon: 'pi pi-home', to: { name: 'dashboard' } },
      breadcrumbItems: [
        { label:'User Profile', to: { name: 'profile.detail' } },
        { label:'User Detail', to: this.$route.path }
      ],
      messages: [],

      options: {
        companies: [],
        branches: []
      }
    }
  },

  created() {
    let flashMessage = this.$session.flash.get("flash-message")
    if(flashMessage) {
      this.messages.push({ severity: this.$session.flash.get("flash-class"), content: flashMessage })
    }

    this.$store.getters.options.companies.forEach(element => {
      this.options.companies.push({ code: element.code, name: element.display })
    })

    this.$store.getters.options.addresses.forEach(element => {
      this.options.branches.push({ code: element.code, name: element.display })
    })
  },

  methods: {
    mapCompany(customer_id) {
      let companyName = this.options.companies.find(element => element.code === customer_id)
      return companyName ? companyName.name : null
    },

    mapBranch(branch_id) {
      let branchName = this.options.branches.find(element => element.code === branch_id)
      return branchName ? branchName.name : null
    }
  }
}
</script>

<style scoped>

</style>
